"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.meetingParticipantSchema = void 0;
const lingo2_models_1 = require("lingo2-models");
const zod_1 = require("zod");
const account_short_1 = require("./account-short");
exports.meetingParticipantSchema = zod_1.z.object({
  id: zod_1.z.string(),
  meeting_id: zod_1.z.string(),
  user_id: zod_1.z.string(),
  accept_status: zod_1.z.nativeEnum(lingo2_models_1.MeetingAcceptStatusEnum),
  billing_status: zod_1.z.nativeEnum(lingo2_models_1.MeetingBillingStatusEnum),
  billing_operation_id: zod_1.z.string().optional(),
  meeting_status: zod_1.z.nativeEnum(lingo2_models_1.MeetingParticipantStatusEnum),
  meeting_current_status: zod_1.z.nativeEnum(lingo2_models_1.MeetingStatusEnum).optional(),
  started_at: zod_1.z.number(),
  finished_at: zod_1.z.number(),
  joined_at: zod_1.z.number(),
  reservation_expires_at: zod_1.z.number(),
  options: zod_1.z.any(),
  state: zod_1.z.any(),
  role: zod_1.z.nativeEnum(lingo2_models_1.MeetingRoleEnum),
  user: account_short_1.accountShortSchema,
  created_at: zod_1.z.number().optional()
});
